/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "eu-west-1",
  aws_cognito_region: "eu-west-1",
  aws_user_pools_id: "eu-west-1_xqdyN2if5",
  aws_user_pools_web_client_id: "3d8fndju02ck04o4kn10bahnf0",
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_xqdyN2if5",
    userPoolWebClientId: "3d8fndju02ck04o4kn10bahnf0",
    mandatorySignIn: false,
    cookieStorage: {
      domain: "app-student.nova.dttsynergy.com",
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: false,
    },
    authenticationFlowType: "USER_SRP_AUTH",
    oauth: {
      domain: "synergy.auth.eu-west-1.amazoncognito.com",
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: "https://app-student.nova.dttsynergy.com/",
      redirectSignOut: "https://app-student.nova.dttsynergy.com/",
      responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["NAME", "EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS",
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsmobile;
